export type CasePartyKind = 'client' | 'requestor' | 'unlinked' | 'needs_review'

export type CasePartySelection = {
  kind: CasePartyKind
  id: string
}

export function partySelectionKey(selection: CasePartySelection | null): string {
  if (!selection) return ''
  return `${selection.kind}:${selection.id}`
}

/** Reply subjects stay locked to the Ticket Request display subject. */
export function lockedReplySubject(displaySubject: string | null | undefined): string {
  const subject = (displaySubject || '').trim()
  if (!subject) return 'Re: Request'
  if (/^(re|fwd?|fw|aw)\s*:/i.test(subject)) return subject
  return `Re: ${subject}`
}

export function queueLabel(kind: 'unlinked' | 'needs_review'): string {
  return kind === 'unlinked' ? 'Unlinked' : 'Needs review'
}

/** Parent ticket label wins. The request status is only the fallback before a parent exists. */
export function caseThreadDisplayStatus(
  request: { status?: string | null; display_status?: string | null; parent_ticket_id?: number | null },
  parentLabels: Readonly<Record<number, string>> = {},
): string {
  const parentId = request.parent_ticket_id
  const fromParent = parentId != null ? (parentLabels[parentId] || '').trim() : ''
  if (fromParent) return fromParent
  const fromPayload = (request.display_status || '').trim()
  if (fromPayload) return fromPayload
  return (request.status || '').trim()
}

/** Shows the suggested ticket request number. A raw id is not a label. */
export function suggestedRequestLabel(requestNumber: string | null | undefined): string | null {
  const number = (requestNumber || '').trim()
  if (!number) return null
  return `Suggested ${number}`
}
